module.exports = __webpack_public_path__ + "static/media/choice.aba519b9.mp3";